import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

// 🔥 إعدادات مشروع Firebase (تأكد أنها مطابقة لما في Firebase Console)
const firebaseConfig = {
  apiKey: "AIzaSyCtF-EEkYMJlsBJNRRiByM5SPAz8a95yl4",
  authDomain: "khidma-app-7649c.firebaseapp.com",
  projectId: "khidma-app-7649c",
  storageBucket: "khidma-app-7649c.firebasestorage.app",
  messagingSenderId: "1030030476404",
  appId: "1:1030030476404:web:096a030ec208bc2432bd21",
  measurementId: "G-QJ9T57E20Z"
};

// تهيئة Firebase
const app = initializeApp(firebaseConfig);

// تهيئة Messaging (فقط في المتصفح)
let messaging = null;

if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
  try {
    messaging = getMessaging(app);
    console.log('✅ Firebase Messaging Initialized');
  } catch (error) {
    console.error('❌ Error initializing Firebase Messaging:', error);
  }
}

export { messaging, getToken, onMessage };
export default app;